import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    retirements: [],
    totalItems:0,
    retirement: {}
};

const getters = {
    index: state => retirementId => state.retirements.findIndex(i => i.retirementId === retirementId)
};

const mutations = {
    setRetirements: (state, r) => (state.retirements = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    setRetirement: (state, r) => (state.retirement = r),
    add: (state, r) => state.retirements.unshift(r),
    edit: (state, { index, r }) => state.retirements.splice(index, 1, r),
    delete: (state, index) => state.retirements.splice(index, 1),
    approval: (state, index) => state.retirements[index].status = status.active,

};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.retirements.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setRetirements", response.data.retirements);
            commit("setTotalItems", response.data.totalItems);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            let formdata = new FormData()
            formdata.append("employeeId", payload.employeeId)
            formdata.append("jobGradeId", payload.jobGradeId)
            formdata.append("correlatorId", payload.correlatorId)
            formdata.append("retirementDate", payload.retirementDate)
            formdata.append("file", payload.file)
            formdata.append("decisionNo", payload.decisionNo)
            formdata.append("remarks", payload.remarks)


            startLoading()
            const response = await dataService.retirements.add(formdata);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.retirement);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.retirements.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async approval({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.retirements.approval(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("approval", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setRetirement", {});
            startLoading()
            const response = await dataService.retirements.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setRetirement", response.data.retirement);
         
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.retirements.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.retirement);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            let formdata = new FormData()
            formdata.append("jobGradeId", payload.jobGradeId)
            formdata.append("correlatorId", payload.correlatorId)
            formdata.append("retirementDate", payload.retirementDate)
            formdata.append("extensionDate", payload.extensionDate)
            formdata.append("file", payload.file)
            formdata.append("decisionNo", payload.decisionNo)
            formdata.append("remarks", payload.remarks)


            startLoading()
            const response = await dataService.retirements.edit(id, formdata);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
         
            const index = getters.index(id);
            commit("edit", { index, r: response.data.retirement });

          /*  return Promise.resolve()*/
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
     async complete({ commit, getters }, { id, payload }) {
        try {
            let formdata = new FormData()
            formdata.append("jobGradeId", payload.jobGradeId)
            formdata.append("correlatorId", payload.correlatorId)
            formdata.append("retirementDate", payload.retirementDate)
            formdata.append("extensionDate", payload.extensionDate)
            formdata.append("file", payload.file)
            formdata.append("decisionNo", payload.decisionNo)
            formdata.append("remarks", payload.remarks)


            startLoading()
            const response = await dataService.retirements.complete(id, formdata);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
         
            const index = getters.index(id);
            commit("edit", { index, r: response.data.retirement });

          /*  return Promise.resolve()*/
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async employeesSearch(_, employeeId) {
        try {

            // startLoading()
            const response = await dataService.retirements.employeesSearch(employeeId);
            // stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            } 
       
            return Promise.resolve(response.data.employee);

        } catch (error) {
            // stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
